<template>
  <div>
    <div class="selected-song">
      <img v-bind:src="assignmentImg"/>
    </div>
    <div>
      <router-link to="/gameplay">
        <img
          class="start-btn"
          src="@/assets/img/アセット 56@3x.png"
          @click="playStart()"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Selectedsong",
  computed: {
    selectedSong() {
      return this.$store.state.selectedSong;
    },
    assignmentImg(){
      return this.$store.state.assignmentImg;
    }
  },
  methods: {
    playStart: async function () {
      const new_axios = this.axios.create({
        headers: {
          Authorization:
            "Bearer " + this.$cookies.get('token'),
          "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
        },
        responseType: "json",
      });
      const body = {
        user_id: this.$store.state.user_id,
        song_id: this.$store.state.selectedSong,
      };
      const endpoint = process.env.API_ENDPOINT + "/plays";
      const response = await new_axios
        .post(endpoint, body)
        .catch(function (error) {
          console.log("エラーだよ", error);
        });
      this.$store.commit("FETCH_ADD_PLAY", response.data.id);
    },
  },
};
</script>

<style>
.selected-song {
  clear: both;
}
.selected-song img {
  width: 500px;
  margin-top: 100px;
}
.start-btn {
  width: 600px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Selectedsong.vue